'use strict';

module.exports = function isValidXss(requestURL) {
  var xssRegex = /(\b)(on\w+)=|javascript|(<\s*)(\/*)script/gi;
  return xssRegex.test(requestURL);
};




//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/helpers/isValidXss.js
// module id = 1115
// module chunks = 0